import React from "react";
import { SBD } from "@opstel/SBD/components/SBD";
import { useQueries } from "@tanstack/react-query";
import { LoadingState } from "@shared/common/components/State/LoadingState";
import { ErrorState } from "@shared/common/components/State/ErrorState";
import { EmptyState } from "@shared/common/components/State/EmptyState";
import { usePrepareStore } from "@shared/common/hooks/usePrepareStore";
import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { useKnopIsLoading } from "@shared/common/hooks/useKnopIsLoading";
import { useCachedActions } from "./SBDAction/useCachedActions";

export function SBDWrapper(): React.JSX.Element {
  const isLoading = useKnopIsLoading((state) => state.isLoading);
  const { knopClient } = useKnopClient();
  const { instanceId } = useCurrentInstanceId();
  const actionsQuery = useCachedActions();

  const queries = useQueries({
    queries: [
      {
        queryKey: instances.current(instanceId).scenario,
        queryFn: () => knopClient.getScenario(instanceId),
      },
      {
        queryKey: instances.current(instanceId).sbdData,
        queryFn: async () => await knopClient.getSbdData(instanceId),
      },
    ],
  });

  const [{ data: scenario }, { data: queriedSbdData }] = queries;
  const { isStoreLoading } = usePrepareStore(scenario, queries);

  if (isLoading || isStoreLoading || queries.some((q) => q.isLoading))
    return <LoadingState fullPage={false} />;
  if (queries.some((q) => q.isError)) {
    queries.filter((q) => q.isError).forEach((q) => console.log(q.error));
    return <ErrorState />;
  }
  if (!scenario || !queriedSbdData || !actionsQuery.data) return <EmptyState />;

  return (
    <SBD
      key={instanceId}
      occupationsForTracks={queriedSbdData.trackOccupations}
      displayConfigurationByTrackCode={queriedSbdData.displayConfigurationByTrackCode}
      trackGroups={queriedSbdData.trackGroups}
    />
  );
}
